import { Injectable } from '@angular/core';
import { IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '@ordersnproducts/features';
import { ProductLineNameCodesTypes } from '@ordersnproducts/modules/shared/constants/product-lines-codes';

@Injectable()
export class CancelOrderFeature implements IFlagFeature {
  name = Features.CancelOrder;

  public isEnabled(container: IToggleContainer, params: { businessLineCode: ProductLineNameCodesTypes }): boolean {
    const businessLineCode = (params && params.businessLineCode) || null;
    const businessLineFeatureCode = Features[`CancelOrder_${businessLineCode}`];

    return container[this.name].isEnabled() && businessLineCode ? container[businessLineFeatureCode].isEnabled() : true;
  }
}
